// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WishListIcon-iconContainer-MH0Tl {
	position: absolute;
	right: 15px;
	top: 15px;
	z-index: 2;
	background: rgba(64, 64, 65, 0.2);
	border-radius: 50%;
	padding: 8px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}
.WishListIcon-buttonContainer-nDZUZ {
    text-align: center;
	cursor: pointer;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
    -webkit-column-gap: 4px;
       -moz-column-gap: 4px;
            column-gap: 4px;
	position: relative;
}
.WishListIcon-wishListIcon-DcIt1 {
	line-height: 1;
	cursor: pointer;
	width: 23px;
	height: 23px;
	/* max-width: 35px; */
}
.WishListIcon-buttonContainer-nDZUZ .WishListIcon-wishListIcon-DcIt1 {
	max-width: 20px !important;
}
.WishListIcon-buttonText-qr7wk {
	padding-left: 1px;
}
.WishListIcon-vtrBottom-dZmbq {
	vertical-align: middle;
}
.WishListIcon-vtrMiddle-fL7z5 {
	vertical-align: middle;
}
.WishListIcon-viewListIcon-UoOVR{
	max-width: 20px !important;
    height: 20px;
}
.WishListIcon-iconAlignCenter-pCdR1{
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}
.WishListIcon-heardIconSize-kLsqF{
	width: 20px;
	height: 20px;
}
.WishListIcon-iconWrapper-KAXYs {
	background: #404041;
	border-radius: 50%;
	padding: 6px;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}
.WishListIcon-tooltip-DI5Be {
	visibility: hidden;
	opacity: 0;
	background: #333;
	color: #fff;
	padding: 8px 12px;
	border-radius: 6px;
	font-size: 12px;
	line-height: 1.4;
	white-space: nowrap;
	pointer-events: none;
}
.WishListIcon-tooltipFixed-XaTpF {
	visibility: visible;
	opacity: 1;
	position: fixed;
	-webkit-transform: translateX(-50%) translateY(-100%);
	    -ms-transform: translateX(-50%) translateY(-100%);
	        transform: translateX(-50%) translateY(-100%);
	z-index: 99999;
	-webkit-transition: opacity 0.2s ease;
	transition: opacity 0.2s ease;
}
.WishListIcon-tooltip-DI5Be::after {
	content: '';
	position: absolute;
	top: 100%;
	left: 50%;
	-webkit-transform: translateX(-50%);
	    -ms-transform: translateX(-50%);
	        transform: translateX(-50%);
	border-width: 5px;
	border-style: solid;
	border-color: #333 transparent transparent transparent;
}
`, "",{"version":3,"sources":["webpack://./src/components/WishListIcon/WishListIcon.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,UAAU;CACV,iCAAiC;CACjC,kBAAkB;CAClB,YAAY;CACZ,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;AACA;IACI,kBAAkB;CACrB,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;IACV,uBAAe;OAAf,oBAAe;YAAf,eAAe;CAClB,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,eAAe;CACf,WAAW;CACX,YAAY;CACZ,qBAAqB;AACtB;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,iBAAiB;AAClB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,0BAA0B;IACvB,YAAY;AAChB;AACA;CACC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,YAAY;AACb;AACA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,YAAY;CACZ,2BAAoB;CAApB,2BAAoB;CAApB,oBAAoB;CACpB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,gBAAgB;CAChB,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,oBAAoB;AACrB;AACA;CACC,mBAAmB;CACnB,UAAU;CACV,eAAe;CACf,qDAA6C;KAA7C,iDAA6C;SAA7C,6CAA6C;CAC7C,cAAc;CACd,qCAA6B;CAA7B,6BAA6B;AAC9B;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,mCAA2B;KAA3B,+BAA2B;SAA3B,2BAA2B;CAC3B,iBAAiB;CACjB,mBAAmB;CACnB,sDAAsD;AACvD","sourcesContent":[".iconContainer {\n\tposition: absolute;\n\tright: 15px;\n\ttop: 15px;\n\tz-index: 2;\n\tbackground: rgba(64, 64, 65, 0.2);\n\tborder-radius: 50%;\n\tpadding: 8px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n.buttonContainer {\n    text-align: center;\n\tcursor: pointer;\n\tdisplay: flex;\n    column-gap: 4px;\n\tposition: relative;\n}\n.wishListIcon {\n\tline-height: 1;\n\tcursor: pointer;\n\twidth: 23px;\n\theight: 23px;\n\t/* max-width: 35px; */\n}\n.buttonContainer .wishListIcon {\n\tmax-width: 20px !important;\n}\n.buttonText {\n\tpadding-left: 1px;\n}\n.vtrBottom {\n\tvertical-align: middle;\n}\n.vtrMiddle {\n\tvertical-align: middle;\n}\n.viewListIcon{\n\tmax-width: 20px !important;\n    height: 20px;\n}\n.iconAlignCenter{\n\talign-items: center;\n}\n.heardIconSize{\n\twidth: 20px;\n\theight: 20px;\n}\n.iconWrapper {\n\tbackground: #404041;\n\tborder-radius: 50%;\n\tpadding: 6px;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n.tooltip {\n\tvisibility: hidden;\n\topacity: 0;\n\tbackground: #333;\n\tcolor: #fff;\n\tpadding: 8px 12px;\n\tborder-radius: 6px;\n\tfont-size: 12px;\n\tline-height: 1.4;\n\twhite-space: nowrap;\n\tpointer-events: none;\n}\n.tooltipFixed {\n\tvisibility: visible;\n\topacity: 1;\n\tposition: fixed;\n\ttransform: translateX(-50%) translateY(-100%);\n\tz-index: 99999;\n\ttransition: opacity 0.2s ease;\n}\n.tooltip::after {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 100%;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\tborder-width: 5px;\n\tborder-style: solid;\n\tborder-color: #333 transparent transparent transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconContainer": `WishListIcon-iconContainer-MH0Tl`,
	"buttonContainer": `WishListIcon-buttonContainer-nDZUZ`,
	"wishListIcon": `WishListIcon-wishListIcon-DcIt1`,
	"buttonText": `WishListIcon-buttonText-qr7wk`,
	"vtrBottom": `WishListIcon-vtrBottom-dZmbq`,
	"vtrMiddle": `WishListIcon-vtrMiddle-fL7z5`,
	"viewListIcon": `WishListIcon-viewListIcon-UoOVR`,
	"iconAlignCenter": `WishListIcon-iconAlignCenter-pCdR1`,
	"heardIconSize": `WishListIcon-heardIconSize-kLsqF`,
	"iconWrapper": `WishListIcon-iconWrapper-KAXYs`,
	"tooltip": `WishListIcon-tooltip-DI5Be`,
	"tooltipFixed": `WishListIcon-tooltipFixed-XaTpF`
};
module.exports = ___CSS_LOADER_EXPORT___;
